import type { PlannerCategory } from "@/graphql/generated-types";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: PlannerCategory): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.title,
    svg: "fas-tag",
    iconBackground: item.color || undefined,
  };
};

const toOption = (item: PlannerCategory): IOption => {
  return {
    value: item.id,
    title: item.title,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
